/**
 * Get weapon image filename from texture ID
 * Example: "SAM_9M8M3_x2" -> "SAM_9M8M3_x2.png"
 */
export function getWeaponImageFilename(textureId: string): string {
  if (!textureId) return "";
  return `${textureId}.png`;
}

/**
 * Get weapon image path from texture ID
 * Example: "SAM_9M8M3_x2" -> "/images/weapons/SAM_9M8M3_x2.png"
 */
export function getWeaponImagePath(textureId: string): string {
  if (!textureId) return "";
  const filename = getWeaponImageFilename(textureId);
  return `/images/weapons/${filename}`;
}

